<template>
  <div>
		<div class="page-wrapper introducer l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title" v-html="$t('introducerText1')"></h1>
				<p class="introducer__text">{{ $t('introducerText2') }}</p>
				<ul class="checklist">
					<li class="checklist__item">{{ $t('checklist1') }}</li>
					<li class="checklist__item">{{ $t('checklist2') }}</li>
					<li class="checklist__item">{{ $t('checklist3') }}</li>
				</ul>
			</div>
			<div>
				<!-- <a class="play" href="#" @click="toggleYoutubeVideoPopup($t('videoYoutubeId'), 1120, 630)"><img :src="require('@/' + $t('introducerImage'))" alt="" class="introducer__image" /></a> -->
			</div>
		</div>
		<div class="page-wrapper introducer introducer--reversed l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title">{{ $t('allianceTitle') }}</h1>
				<p class="introducer__text" v-html="$t('allianceText1')"></p>
				<p class="introducer__text" v-html="$t('allianceText2')"></p>
				<p class="separator"></p>			
			</div>
			<div><img :src="require('@/assets/pages/associations/mosaic.jpg')" alt="" class="introducer__image introducer__image--small" /></div>
		</div>
		<div class="page-wrapper introducer">
			<app-box>
				<template v-slot:title>
					<div class="product">
						<img class="product__image" src="@/assets/pages/associations/mobile.jpg" alt=""/>
						<h1 class="product__title" v-html="$t('mobileTitle')"></h1>
					</div>
				</template>
				<template v-slot:description>
					<p class="product__description">{{ $t("mobileDescription") }}</p>
					<p class="separator"></p>
				</template>
				<template v-slot:buttons>
					<div class="product__buttons">
						<router-link :to="$locale.toRouteLinkProp('mobile')" class="button button--secondary">{{ $t("general.learnMore") }}</router-link>
					</div>
				</template>						
			</app-box>
			<app-box>
				<template v-slot:title>
					<div class="product">
						<img class="product__image" src="@/assets/pages/associations/crm.jpg" alt=""/>
						<h1 class="product__title" v-html="$t('crmTitle')"></h1>
					</div>
				</template>
				<template v-slot:description>
					<p class="product__description">{{ $t("crmDescription") }}</p>
					<p class="separator"></p>
				</template>
				<template v-slot:buttons>
					<div class="product__buttons">
						<router-link :to="$locale.toRouteLinkProp('crm')" class="button button--secondary">{{ $t("general.learnMore") }}</router-link>
					</div>
				</template>						
			</app-box>
		</div>
		<div class="testimonials l-mt-80">
			<h1 class="testimonials__title">{{ $t("testimonialsTitle") }}</h1>
			<testimonials :testimonials="testimonials"></testimonials>
		</div>
	</div>
</template>


<script>
import videoMixin from '@/video-mixin.js'
import AppBox from '@/components/utils/AppBox.vue'
import Testimonials from '@/components/utils/Testimonials.vue'

export default {
	components: { Testimonials, AppBox },
  	mixins: [videoMixin],
	mounted () {

	},

	data () {
		return {
			testimonials: [
				{
					name: 'Art Carter',
					title: 'CEO, CRMLS®',
					text: 'There are so many products and vendors on the market and they all promise great value and service. Prospects has not only provided a great product for our members  they have also set the standard for how vendors should treat their clients. If something does not work, they fix it right away. If they can’t do it right away they provide a clear explanation and timeline. ',
					image: 'art.jpg'
				},
				{
					name: 'Éric Charbonneau',
					title: 'CEO, Centris®',
					text: 'We were in need of an application that is intuitive, user friendly and that works seamlessly across the board with all mobile devices.  brought us all that and more!',
					image: 'eric.jpg'
				},
			],
		}
	},
	i18n: {
		messages: {
			'en-CA': {
				checklist1: "Matrix™",
				checklist2: "CRM",
				checklist3: "Mobile Real Estate App",
				introducerImage: "assets/pages/associations/introducer.jpg",
				introducerText1: "Essential Tools<br/>For Your Members",
				introducerText2: "Which products should be part of the essential tools you offer to your members?",
				videoYoutubeId: "ZMB1BjkLcmk",
				allianceTitle: "Seamlessly integrated with CoreLogic Listing Management & Tax Platforms ",
				allianceText1: "We’ve created the perfect technology hub for your members where real-time data flows seamlessly and automatically between CoreLogic’s Listing Management Platform (Matrix™), Property Insights Platform (Realist®), and our Prospects CRM and @:(mobileName) solutions.",
				allianceText2: "Your members will get the mobile experience they deserve with easy on-the-go access to critical listing, tax, and contact data. And they’ll have access to powerful engagement and follow-up tools only possible with the deep integrations that are available between Matrix and Prospects CRM.",
				mobileTitle: "Prospects<br>Mobile",
				mobileDescription: "Give your members the mobile experience they deserve.  provides easy access to listing, roster, and client data in the palm of their hand. Fully integrated with CoreLogic Listing Management Platform (Matrix™). Listing status, price, and remarks can be edited on-the-go. Agents can also Brand & Share the app with their clients and seamlessly collaborate like never before. ",
				crmTitle: "Prospects<br>CRM", 
				crmDescription: "Help your members grow their business with our industry leading real estate CRM solution, Prospects CRM. Agents can effectively nurture new leads, and maximize their sphere of influence and past clients. Seamless integrations with their CoreLogic Listing Management Platform (Matrix™) will give them premium engagement and follow-up tools to help supercharge their marketing.",
				testimonialsTitle:"What people are saying about Prospects"
			},
			'en-US': {
				allianceTitle: "Seamlessly integrated with CoreLogic MLS & Tax Platforms ",
				checklist3: "Mobile MLS",
				mobileTitle: "MLS-Touch",
				mobileDescription: "Give your members the mobile experience they deserve. MLS-Touch provides easy access to listing, tax, roster, and client data in the palm of their hand. Fully integrated with CoreLogic Listing Management Platform (Matrix™) and Property Insights (Realist®). Listing status, price, and remarks can be edited on-the-go. Agents can also Brand & Share the app with their clients and seamlessly collaborate like never before. ",
			}
		}
	}
}
</script>

<style scoped>
	.introducer { display: flex; align-items: center; }
	.introducer--reversed { flex-direction: row-reverse; }
	.introducer > * { flex: 1; }
	.introducer > *:first-child { margin-right: 40px; }
	.introducer__title { font-size: 3.5rem; font-weight: 700; padding: 20px 0; }
	.introducer__text { line-height: 1.5; color: #666; }
	.introducer__image { max-height: 650px; max-width: 100%; }
	.introducer__image--small { max-height: 400px; }
	.introducer__applications { display: flex; }
	.introducer__application { margin-right: 10px; }
	.introducer__conditions { margin-top: 30px; color: grey; font-size: 1.2rem; }
	.play { display: flex; align-items: center; font-weight: 700; margin: 40px 0; }
	.play svg { height: 40px; margin-right: 10px; }
	.showcaser-title { font-size: 2.7rem; font-weight: 700; }
	.showcase-text { padding: 10px 0; line-height: 1.5; color: #666; }
	.checklist { display: flex; list-style: none; margin-top: 20px; font-weight: bold; }
	.checklist__item { position: relative; padding-left: 30px; margin-right: 20px; }
	.checklist__item::before { content: " "; background: url(/img/check.1c2decf9.svg); width: 23px; height: 100%; left: 0; position: absolute; }
	.product { display: flex; }
	.product__title { font-size: 3rem; font-weight: 500; margin-left: 20px; }
	.product__image { height: 125px; }
	.product__description { font-size: 1.6rem; line-height: 1.5; color: #666; position: relative; padding-top: 20px; }
	.separator { padding: 0; width: 75px; height: 5px; margin: 20px 0; position: relative; }
	.separator::after { content: " "; position: absolute; left:0; bottom: 0; height: 5px; width: 75px; border-radius: 30px; background: linear-gradient(to right, rgb(145,0,0), rgb(203,0,0) 50%); }
	.product__buttons { display: flex; justify-content: flex-end; }
	.testimonials { padding: 40px 0; text-align: center; background: #F9F9F9; }
	.testimonials__title { padding-bottom: 40px; font-size: 4rem; font-weight: bold; color: #343434; }

	@media (max-width: 768px) {
		.introducer { flex-direction: column; justify-content: center; text-align: center; }
		.introducer > *:first-child { margin-right: 0; }
		.introducer__content { display: flex; flex-direction: column; align-items: center; }
		.play { margin: 20px 0; }
		.product { align-items: center; }
	}
</style>
